module.exports = __webpack_public_path__ + "img/knowledge.a42d4b9e.svg";